import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import App from './containers/App';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from './redux/store';
import antdTheme from './theme/antdTheme';
import { AppToaster } from './wrappers/toast';
import { ConfirmProvider } from './wrappers/layout/BaseConfirm';
// tokens first — every other stylesheet reads its custom properties
import './theme/tokens.css';

store.subscribe(() => { store.getState() })
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={ store }>
    <ConfigProvider theme={ antdTheme }>
      <BrowserRouter>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
        {/* one toast stack for the whole app, auth screens included */ }
        <AppToaster />
      </BrowserRouter>
    </ConfigProvider>
  </Provider>
);

// Hand off from the static splash in index.html once React has painted, so
// there is never a white gap between the two.
const splash = document.getElementById("app-splash");
if (splash) {
  requestAnimationFrame(() => {
    splash.style.transition = "opacity 220ms ease";
    splash.style.opacity = "0";
    setTimeout(() => splash.remove(), 240);
  });
}
